__turbopack_context__.v({
  "auto-complete": "auto-complete-module-scss-module__yHRY8q__auto-complete",
  "end": "auto-complete-module-scss-module__yHRY8q__end",
  "error": "auto-complete-module-scss-module__yHRY8q__error",
  "full-width": "auto-complete-module-scss-module__yHRY8q__full-width",
  "inputs-container": "auto-complete-module-scss-module__yHRY8q__inputs-container",
  "loading": "auto-complete-module-scss-module__yHRY8q__loading",
  "middle": "auto-complete-module-scss-module__yHRY8q__middle",
  "middle-line": "auto-complete-module-scss-module__yHRY8q__middle-line",
  "popover": "auto-complete-module-scss-module__yHRY8q__popover",
  "popover-header": "auto-complete-module-scss-module__yHRY8q__popover-header",
  "popover-history-bottom": "auto-complete-module-scss-module__yHRY8q__popover-history-bottom",
  "popover-history-title": "auto-complete-module-scss-module__yHRY8q__popover-history-title",
  "popover-list": "auto-complete-module-scss-module__yHRY8q__popover-list",
  "popover-list-divider": "auto-complete-module-scss-module__yHRY8q__popover-list-divider",
  "popover-list-title": "auto-complete-module-scss-module__yHRY8q__popover-list-title",
  "start": "auto-complete-module-scss-module__yHRY8q__start",
  "swap-button": "auto-complete-module-scss-module__yHRY8q__swap-button",
  "swap-button-icon": "auto-complete-module-scss-module__yHRY8q__swap-button-icon",
});
